function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-list_svg__clip0)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.219 9.219H5.635a.781.781 0 100 1.562H19.22a.781.781 0 100-1.562zM19.219 3.36H5.635a.781.781 0 100 1.562H19.22a.781.781 0 100-1.563zM19.219 15.078H5.635a.781.781 0 000 1.563H19.22a.781.781 0 100-1.563zM1.055 5.195a1.055 1.055 0 100-2.11 1.055 1.055 0 000 2.11zM1.055 11.055a1.055 1.055 0 100-2.11 1.055 1.055 0 000 2.11zM1.055 16.914a1.055 1.055 0 100-2.11 1.055 1.055 0 000 2.11z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-list_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconList;